export default {
    path: 'bindaccount',
    component: () => import( /* webpackChunkName: "common-list" */ '@/pages/bindaccount/BindAccList'),
    meta: {
        title: '个人设置'
    },
    children: [{
        path: 'resetpwd',
        component: () => import( /* webpackChunkName: "task-list" */ '@/pages/bindaccount/ResetPwd'),
        meta: {
            title: '重置密码'
        },
        hidden: true
    }]
}